export enum ErrorMessage {
  PROCESSING_ERROR = 'There was an error processing your request.' +
    ' Please try to refresh the page or to contact Quantuvis Customer Support for more details.',
  COMMON_SERVER_ERROR =
    'Something went wrong. Please try again or contact Quantuvis customer support.'
}
